export default __webpack_public_path__ + "static/media/pets.47019722.webp";